import styled, { createGlobalStyle } from "styled-components";
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

export const ConfirmModalStyles = createGlobalStyle`
  .ant-modal-confirm .ant-btn-primary {
    background-color: #0B2A1B !important;
    border-color: #0B2A1B !important;
    &:hover {
      background-color: #0d3322 !important;
      border-color: #0d3322 !important;
    }
  }

  .ant-modal-confirm .ant-btn-default {
    border-color: #0B2A1B !important;
    color: #0B2A1B !important;
    &:hover {
      background-color: #0B2A1B !important;
      border-color: #0B2A1B !important;
      color: #fff !important;
    }
  }

  .ant-modal-confirm .anticon-exclamation-circle {
    color: rgb(245, 34, 45) !important;
  }
`;

const ModalHealthSafetyWrap = styled(Modal)`
  .btn-success{
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    &:hover{
      opacity: 0.8;
    }
  }
`;

export default WithDirection(ModalHealthSafetyWrap);
